'use client'

import { LightProgressLoader } from '@fsg/gui-bits'

export function LightbulbLoading() {
  return (
    <div className="absolute inset-0 m-auto p-[25vh]">
      <LightProgressLoader />
    </div>
  )
}
